import React from 'react';

import SalesPortalLayout from 'layouts/SalesPortalLayout';

import { IRouteMap } from './types';

export const salesPortalRouteMap: IRouteMap = {
  layout: SalesPortalLayout,
  routes: [
    {
      key: 'sales-portal-home-page',
      component: React.lazy(() => import('pages/sales-portal/SalesPortalHomePage')),
      path: 'sales-portal/:salesPortalSlug',
    },
    {
      key: 'sales-portal-package',
      component: React.lazy(() => import('pages/sales-portal/SalesPortalPackagePage')),
      path: 'sales-portal/:salesPortalSlug/:packageId',
    },
    {
      // Abandoned-checkout recovery landing page (spec Item 11). The static `resume`
      // segment outranks the dynamic `:packageId/:billingPlanId` pattern in react-router.
      key: 'sales-portal-resume',
      component: React.lazy(() => import('pages/sales-portal/SalesPortalResumePage')),
      path: 'sales-portal/:salesPortalSlug/resume/:token',
    },
    {
      key: 'sales-portal-billing-plan',
      component: React.lazy(() => import('pages/sales-portal/SalesPortalBillingPlan')),
      path: 'sales-portal/:salesPortalSlug/:packageId/:billingPlanId',
    },
  ],
  navLinks: [],
};

export const getSalesPortalRouteMap = (): IRouteMap => {
  return salesPortalRouteMap;
};
